import { ReactNode } from "react";
import { Dialog, styled } from "@mui/material";

interface Props {
  children: ReactNode;
  isDialogOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
}

export function StyledDialog(props: Props) {
  const { isDialogOpen, setIsDialogOpen, children } = props;
  return (
    <Styles open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
      {children}
    </Styles>
  );
}

const Styles = styled(Dialog)`
  z-index: 9999;
  .MuiDialog-paper {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;
